module.exports = __webpack_public_path__ + "img/users-cog-regular.63a8723e.svg";